import { emailValidaotr, mandatoryFieldValditor, mobileValidator, pinCodeValidator } from 'common/utils/validator';
import { ADDRESS_TYPE_ENUM, formElement } from 'home/view/manage-feasibility/constants';
import { prepareOptionsForDropDown } from 'dedicated/services/summary.service';

export const billableIdFormKey = 'billableId';
export const keysToIgnoreForExistingAddress = ['city', 'address', 'email', 'mobileNumber', 'pinCode', 'personName', billableIdFormKey];
export const KEYS_TO_IGNORE_LSI = ['city', 'existingAddress', 'mobileNumber', 'pinCode', 'personName', 'email', 'companyName', 'address', billableIdFormKey];
export const BILLING_TYPE_LSI = 'LSI';

export const formSchema = {
  type: { id: 'ACCOUNT', displayName: 'Account Level' },
  paymentType: '',
  paymentCycle: '',
  companyName: '',
  existingAddress: '',
  [billableIdFormKey]: { ...formElement },
  accountNumber: { ...formElement }
};

export const accountDetailSchema = {
  companyName: '',
  accountNumber: '',
  parentAccountNumber: '',
  rootAccountNumber: '',
  gstNumber: '',
  gstSez: '',
  billingAddress: {
    pincode: '',
    state: '',
    city: '',
    addressLine1: '',
    addressLine2: ''
  },
  contacts: [
    {
      contactId: '',
      contactType: '',
      firstName: '',
      lastName: '.',
      middleName: '',
      designation: '',
      email: '',
      phoneNumber: ''
    }
  ],
  billable: true
};

const setAccountAndBillableId = (parentAccountNumber, { billableId, crmNbaId }) => {
  const accountNumberValue = parentAccountNumber ? parentAccountNumber : crmNbaId;
  formSchema.accountNumber = { ...formSchema.accountNumber, value: { displayName: accountNumberValue, key: accountNumberValue } };
  formSchema.billableId = { ...formSchema.accountNumber, value: { displayName: billableId, key: billableId } };
};

const setBillingTypesAndPayment = ({ billingCycle, billingType }) => {
  const billingTypeOptions = prepareOptionsForDropDown(['Advance', 'Arrear'], null, null, 'Billing');
  const billingTypeValue = billingType ? billingTypeOptions.find(({ key }) => key === billingType) : billingTypeOptions[0];
  const billingPaymentCycleOptions = prepareOptionsForDropDown(['Quarterly', 'Monthly', 'Half-yearly', 'Annually']);
  const billingPaymentCycleValue = billingCycle ? billingPaymentCycleOptions.find(({ key }) => key === billingCycle) : billingPaymentCycleOptions[0];
  formSchema['paymentType'] = { ...formElement, value: billingTypeValue, options: billingTypeOptions };
  formSchema['paymentCycle'] = { ...formElement, value: billingPaymentCycleValue, options: billingPaymentCycleOptions };
};

export const getDefaultValue = (order) => {
  const {
    billingLevel,
    parentAccountNumber,
    companyAddress: { addressLine1 },
    lead: { customer }
  } = order;

  formSchema['type'] = getBillingOptionById(billingLevel);
  setBillingTypesAndPayment(order);
  formSchema['companyName'] = customer && customer.authorizedSignatory && customer.authorizedSignatory.companyName;
  setAccountAndBillableId(parentAccountNumber, customer);

  return formSchema;
};

export const billingTypeOption = [
  { id: 'ACCOUNT', displayName: 'Account Level' },
  { id: 'PO', displayName: 'PO Level' },
  { id: 'LSI', displayName: 'Circuit level' }
];

export const getBillingOptionById = (billingLevel) => {
  return billingTypeOption.filter(({ id }) => id === billingLevel)[0];
};
